import React, { useState } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import "./index.css";
import { maskSSN } from '../../utils/helper';

const TextInput = ({ label, type, placeholder, options=[], value, onChange, formik, keyField= "", readOnly=false, required = true, onKeyPress, onBlur }) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleSSNChange = (e) => {
    let inputValue = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
    if (inputValue.length > 3 && inputValue.length <= 5) {
      inputValue = inputValue.replace(/(\d{3})(\d{0,2})/, '$1-$2');
    } else if (inputValue.length > 5) {
      inputValue = inputValue.replace(/(\d{3})(\d{2})(\d{0,4})/, '$1-$2-$3');
    }
    onChange({
      ...e,
      target: {
        ...e.target,
        value: inputValue
      }
    });
  };

   const handleSelectChange = (e) => {
    const val = e.target.value === '' ? null : e.target.value;
    onChange({
      ...e,
      target: {
        ...e.target,
        value: val
      }
    });
  };

  const renderInput = () => {
    switch (type) {
      case 'select':
        return (
          <div className='input-field'>
          <div style={{ position: 'relative' }}>
            <Input
              type="select"
              value={value ?? ''}
              onChange={handleSelectChange}
              disabled={readOnly}
              name={keyField}
            >
              {/* Make this not disabled and no "selected" attribute (React handles it via value) */}
              <option value="">--Select--</option>
              {options && options.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>

            {/* Clear button shown when a value is selected and not read-only */}
            {!readOnly && value && (
              <button
                type="button"
                className="clear-btn"
                // onClick={() => onChange({ target: { value: '' } })}
                onClick={() => onChange({ target: { name: keyField, value: null } })}
                style={{
                  position: 'absolute',
                  top: '50%',
                  right: '25px',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                  lineHeight: '1'
                }}
                aria-label="Clear selection"
              >
                <i className="fa fa-times" />
              </button>
            )}
          </div>

          <div>
            {formik?.touched[keyField] && formik?.errors[keyField] ? (
              <span style={{ color: 'red' }}>{formik?.errors[keyField]}</span>
            ) : ""}
          </div>
        </div>
        );
      case 'phone':
        return (
          <div>
            <div>
            <PhoneInput
              inputProps={{
                name: 'phone',
                autoFocus: true
              }}
              className="number"
              country={'us'}
              onlyCountries={['us']}
              containerClass="react-tel-input"
              inputClass="form-control"
              value={value}
              onChange={onChange}
            />
          </div>
           <div>
              {formik?.touched[keyField] && formik?.errors[keyField] ? <span style={{color : "red"}}>{formik?.errors[keyField]}</span> : ""}
            </div>
          </div>
        );
        case 'ssn':
          return (
            <div className='input-field'>
              <div>
                <Input
                  type="text"
                  placeholder={placeholder}
                  value={isEditing ? value : maskSSN(value)}
                  onChange={isEditing ? handleSSNChange : undefined}
                  onFocus={() => setIsEditing(true)} // Enter edit mode on focus
                  onBlur={(e) => {
                    setIsEditing(false); // Exit edit mode on blur
                    if (onBlur) onBlur(e); // Call optional onBlur prop
                  }}
                  disabled={readOnly}
                  maxLength="11" // 9 digits + 2 dashes
                  onKeyPress={onKeyPress}
                />
              </div>
              <div>
                {formik?.touched[keyField] && formik?.errors[keyField] ? (
                  <span style={{ color: 'red' }}>{formik?.errors[keyField]}</span>
                ) : (
                  ''
                )}
              </div>
            </div>
          );
        default:
        return (
          <div className='input-field'>
            <div>
              <Input type={type} placeholder={placeholder} value={value} onChange={onChange} disabled={readOnly} onKeyPress={onKeyPress} onBlur={onBlur}/>
            </div>
            <div>
              {formik?.touched[keyField] && formik?.errors[keyField] ? <span style={{color : "red"}}>{formik?.errors[keyField]}</span> : ""}
            </div>
          </div>
        );
    }
  };

  return (
    <FormGroup>
      <Label>{label}</Label>
      {required ? <span style={{color : "red", marginLeft:"3px"}}>*</span> : null}
      {renderInput()}
    </FormGroup>
  );
};

export default TextInput;

